<template>
	<div class="single_file_download" v-if="is_currentDownload">
		<!-- 单文件下载 -->
		<el-dialog :title="downloadTextShow" :visible.sync="dialogDownload" @close="dialogClose">
			<div class="down-shelf-text">
				<div class="down-rogress">{{ fileName_i }} - 当前进度</div>
				<el-progress
					:text-inside="true"
					:stroke-width="24"
					:color="colorStatus[statusLoading]"
					:percentage="pro_percentage"
					status="success"
				></el-progress>
			</div>
		</el-dialog>

		<div
			class="small-skylight"
			v-if="!dialogDownload && is_currentDownload"
			@click="dialogDownload = true"
		>
			<el-progress
				:color="colorStatus[statusLoading]"
				type="circle"
				:percentage="pro_percentage"
			></el-progress>
		</div>
		<!-- 单文件下载 end -->
	</div>
</template>

<script>
	import axios from 'axios';
	const CancelToken = axios.CancelToken;
	import FileSaver from 'file-saver';
	export default {
		name: 'single_file_download',
		props: {
			url: {
				type: String,
			},
			title: {
				type: String,
			},
			subtitle: {
				type: String,
			},
		},
		data() {
			return {
				// 单文件下载
				fileName_i: '', // 下载提示
				statusLoading: 'down',
				colorStatus: {
					down: '#f56c6c',
					bale: '#e60000',
				},
				// 显示下载 弹窗
				dialogDownload: false,
				// 当前是否有下载
				is_currentDownload: false,
				// 弹窗提示
				downloadTextShow: '正在下载',
				// 当前进度
				pro_percentage: 0,
				cancel: () => {},
				is_clickCancel: false,
			};
		},
		created() {},
		methods: {
			async downloadItem(file, file_title) {
				// 下载提示 初始化
				this.fileName_i = file_title;
				this.statusLoading = 'down';
				this.dialogDownload = true;
				this.is_currentDownload = true;
				this.pro_percentage = 0;
				if (file.size >= 1024 ** 2 * 250) {
					window.open(this.$route.fullPath, '_blank'); // 跳转到新页面
				}

				const promise = await this.getFile(
					file.url,
					(ing) => {
						let complete = parseInt((ing.loaded / ing.total) * 100);
						this.pro_percentage = complete;
					},
					(c) => {
						this.cancel = c;
					},
					() => {}
				);

				FileSaver.saveAs(promise, `${file_title}`); // 保存文件  修改名称

				// 下载 结束
				this.statusLoading = 'bale';
				this.dialogDownload = false;
				this.is_currentDownload = false;
				return promise;
			},

			/**
			 * 获取文件
			 * @param url 文件路径
			 * @returns {Promise<unknown>}
			 */
			async getFile(url, loading, cancel, errFn = () => {}) {
				return await new Promise((resolve, reject) => {
					axios({
						method: 'get',
						url,
						responseType: 'blob',
						cancelToken: new CancelToken(cancel),
						// responseType: 'arraybuffer'
						onDownloadProgress: (progressEvent) => {
							if (loading) {
								loading(progressEvent);
							}
						},
					})
						.then((data) => {
							resolve(data.data);
						})
						.catch((error) => {
							errFn();
							reject(error.toString());
						});
				});
			},

			// 关闭弹窗
			dialogClose() {
				if (this.pro_percentage > 90 && this.pro_percentage < 100) {
					this.$message.error('即将下载完成 请耐心等待');
					return;
				}

				if (this.is_currentDownload) {
					this.$confirm('文件正在下载中！', '提示', {
						confirmButtonText: '等待下载',
						cancelButtonText: '取消下载',
						type: 'warning',
					})
						.then(() => {
							this.dialogDownload = false;
							this.$message.error({
								message: '文件正在下载,请勿关闭当前页面',
								showClose: true,
							});
						})
						.catch(() => {
							this.is_clickCancel = true;
							this.cancel();
							this.statusLoading = 'bale';
							this.dialogDownload = false;
							this.is_currentDownload = false;
						});
				}

				// this.dialogDownload = false;
				// if (this.is_currentDownload) {
				//   this.$message.error({
				//     message: "文件正在下载,请勿关闭当前页面",
				//     showClose: true,
				//   });
				// }
			},
		},
	};
</script>

<style lang="scss" scope>
	/* // 下载提示   */
	.small-skylight {
		position: fixed;
		top: 70px;
		right: 160px;
		z-index: 9999;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 6px;
		width: 70px;
		height: 70px;
		border-radius: 50%;
		background-color: #fff;
		box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.4);

		animation-name: tilt-in-bl;
		animation-duration: 1s;
		animation-timing-function: ease;
		animation-delay: 0s;
		animation-iteration-count: 1;
		animation-direction: normal;
		animation-fill-mode: none;
	}

	@keyframes tilt-in-bl {
		0% {
			transform: rotateY(35deg) rotateX(-20deg) translate(-250px, 250px) skew(-12deg, -15deg);
			opacity: 0;
		}
		100% {
			transform: rotateY(0) rotateX(0deg) translate(0, 0) skew(0deg, 0deg);
			opacity: 1;
		}
	}
</style>
